import { useEffect, useMemo, useState } from 'react';
import { listBulkPricingOperations } from '../api/bulkPricingApi';
import { getSelectedCompanyId } from '../utils/selectedCompany';

export default function usePriceListPendingChanges({ branchId, userId, enabled, refreshKey }) {
  const companyId = getSelectedCompanyId();
  const scopeKey = `${companyId}:${userId}:${branchId}`;
  const [result, setResult] = useState({ scopeKey: '', operations: [], error: '' });
  const [version, setVersion] = useState(0);
  useEffect(() => {
    if (!enabled || !branchId) return undefined;
    let active = true;
    listBulkPricingOperations({ scope: 'price_list', branchId }).then((response) => {
      if (active) setResult({ scopeKey, operations: response.operations || [], error: '' });
    }).catch(() => {
      if (active) setResult({ scopeKey, operations: [], error: 'No se pudieron cargar las advertencias de cambios pendientes.' });
    });
    return () => { active = false; };
  }, [branchId, enabled, scopeKey, refreshKey, version]);

  const operationsByFormat = useMemo(() => {
    const byFormat = {};
    if (enabled && result.scopeKey === scopeKey) {
      result.operations.filter((operation) => operation.pendingCount > 0).forEach((operation) => {
        (operation.pendingFormatIds || []).forEach((formatId) => {
          (byFormat[formatId] ||= []).push(operation);
        });
      });
    }
    return byFormat;
  }, [enabled, result, scopeKey]);
  return { operationsByFormat, error: enabled && result.scopeKey === scopeKey ? result.error : '', refresh: () => setVersion((value) => value + 1) };
}
